// !!! IMPORTANT !!!
//
// This file is shared between the zapier/zapier and zapier/next-js repository.
// Any changes made here should be reflected in there as well.
// For more information, see: https://zapier.quip.com/xaKqAOpdhpY2#ZXFACA8Jnp9

import PropTypes from 'prop-types';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import React from 'react';
import createReactClass from 'create-react-class'; // eslint-disable-line no-restricted-syntax
import bemify, { toModifiers } from 'bemify-js';

import { Icon } from '@zapier/common-components';

import { getRef, setRef } from 'web-ssr/app/common/utils/ReactUtils';
import 'web-ssr/app/common/components/NotificationsMenu/NotificationBell.scss';

const bem = bemify('notification-bell');

const NotificationBell = createReactClass({
  displayName: 'NotificationBell',
  mixins: [PureRenderMixin],

  propTypes: {
    unreadCount: PropTypes.number.isRequired,
    hasUndelivered: PropTypes.bool.isRequired,
    hasImportant: PropTypes.bool.isRequired,
    onBellRingFinished: PropTypes.func.isRequired,
  },

  getDefaultProps() {
    return {
      hasUndelivered: false,
      hasImportant: false,
    };
  },

  componentDidMount() {
    const { onBellRingFinished } = this.props;
    const bell = getRef(this, 'bell');

    // We only animate when delivering notifications, so if an animation ends,
    // notifications have been delivered. Wait until the animation ends before
    // marking as delivered, otherwise the animation can get cut off with a re-render.
    bell.addEventListener('animationend', onBellRingFinished);
  },

  render() {
    const { unreadCount, hasUndelivered, hasImportant } = this.props;
    const hasUnread = unreadCount > 0;
    const unreadModifier = toModifiers({ unread: hasUnread });
    const animateModifier = toModifiers({ animate: hasUndelivered });
    const delayAnimationModifier = toModifiers({
      animateDelay: hasUndelivered && !hasImportant,
    });

    return (
      <div className={bem()}>
        <div
          className={bem(
            '__icon-container',
            animateModifier,
            delayAnimationModifier
          )}
          ref={setRef(this, 'bell')}
        >
          <Icon
            className={bem('__icon', unreadModifier)}
            name="bell"
            size={18}
          />
        </div>
        {!hasUnread ? null : (
          <div className={bem('__counter', animateModifier)}>{unreadCount}</div>
        )}
      </div>
    );
  },
});

export default NotificationBell;
